import React from 'react';
import { IconButton, IconButtonProps } from 'pounceV2';

const OptionsButtonV3 = React.forwardRef<HTMLButtonElement, Partial<IconButtonProps>>(
  function OptionsButton(props, ref) {
    return (
      <IconButton
        variant="ghost"
        icon="options-dots-vertical"
        size="small"
        aria-label="Toggle Options"
        {...props}
        ref={ref}
      />
    );
  },
);

export default OptionsButtonV3;
